module.exports = __webpack_public_path__ + "static/media/ysfx.fc76bf6c.PNG";